import api from '../';

class MemoGameApi {
    static getGroups(locale) {
        return api.axios.get('/memo/groups', { params: { locale } }).then(response => response.data);
    }

    static getItemsByRequest(params) {
        return api.axios.get('/memo/items', { params }).then(response => response.data.items);
    }
}

export default MemoGameApi;
